const numberToCurrency = (val, curr = 'R$') => {
    if (val && typeof val === 'number') {
        return `${curr} ${val.toFixed(2).replace('.', ',')}`
    }
    return val
}

export default numberToCurrency
